import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Only scroll to top if there's no hash (hash navigation should go to specific sections)
    if (!hash) {
      // Use multiple methods to ensure scroll to top works
      const scrollToTop = () => {
        // Method 1: Direct scroll
        window.scrollTo(0, 0);
        
        // Method 2: Modern API
        if (window.scrollTo) {
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
          });
        }
        
        // Method 3: Fallback for older browsers
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      };

      // Use setTimeout to ensure DOM is ready
      const timeout = setTimeout(scrollToTop, 0);
      
      // Also try after a short delay to handle any async rendering
      const delayedTimeout = setTimeout(scrollToTop, 50);

      return () => {
        clearTimeout(timeout);
        clearTimeout(delayedTimeout);
      };
    }
  }, [pathname, search, hash]);

  // Handle initial page load
  useEffect(() => {
    // Only scroll to top on initial load if no hash
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [hash]);

  return null;
}

export default ScrollToTop;
